module.exports = __webpack_public_path__ + "img/61.629752c4.jpg";